import { gql, TypedDocumentNode } from '@apollo/client';
import type { ProductInventoryItem } from '../models/ProductInventoryItem';

export const ADD_PRODUCT_INVENTORY_ITEM_MUTATION: TypedDocumentNode<{ added: boolean }, { input: ProductInventoryItem }> = gql`
  mutation AddProductInventoryItem($input: ProductInventoryItemModelInput!) {
    added: addProductInventoryItem(input: $input)
  }
`;

export const UPDATE_PRODUCT_INVENTORY_ITEM_MUTATION: TypedDocumentNode<{ updatedProductInventoryItem: ProductInventoryItem }, { input: ProductInventoryItem }> = gql`
  mutation UpdateProductInventoryItem($input: ProductInventoryItemModelInput!) {
    updatedProductInventoryItem: updateProductInventoryItem(input: $input) {
      id,
      packagingType,
      quantityOnHand,
      batchId
    }
  }
`;

export const DELETE_PRODUCT_INVENTORY_ITEM_BY_ID_MUTATION: TypedDocumentNode<{ deleted: boolean }, { id: number }> = gql`
  mutation DeleteProductInventoryItemById($id: Int!) {
    deleted: deleteProductInventoryItemById(id: $id)
  }
`;